module.exports = __webpack_public_path__ + "officialStatic/img/index-product-sw.35a8e53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-product-sw.png
// module id = zfHr
// module chunks = 0